import React, { Component } from "react";
import {
  withStyles,
  //   createMuiTheme,
  //   MuiThemeProvider,
} from "@material-ui/core/styles";
import SchoolLoader from "../../Assets/Logo/SchoolLoader.gif";

import { useStyles } from "./CustomSiteLoader.css";
// const theme = createMuiTheme({
//   palette: {
//     primary: {
//       main: "#1b67a3",
//     },
//   },
// });

class CustomSiteLoader extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <img
          src={SchoolLoader}
          alt="Loader"
          style={{ width: 200, height: 200 }}
        />
      </div>
    );
  }
}

export default withStyles(useStyles)(CustomSiteLoader);
